import { GET_USER_ADDRESS, SUBMIT_SCHEDULE_INTERVIEW } from '../../action-contants';
import { API_URL } from '../../../utils/config';
import { handleError } from '../common-message/message-action';
import { getNextScreenFromState, makeApiCall } from '../common/common-action';
import { getUniqueSessionId } from '../../../utils/library';

function setUserAddress(data) {
  return {
    type: GET_USER_ADDRESS,
    data
  };
}

export function submitAppointment(data) {
  return {
    type: SUBMIT_SCHEDULE_INTERVIEW,
    data
  };
}

export function getUserAddress(paramObject) {
  return async (dispatch) => {
    try {
      const params = {};
      if (paramObject) {
        Object.keys(paramObject).forEach((key) => {
          params[key] = paramObject[key];
        });
      }
      const response = await makeApiCall({
        method: 'get',
        url: `${API_URL}/remitter/appointment/address`,
        withCredentials: true,
        params
      });
      if (response && response.data && response.data.success) {
        await dispatch(setUserAddress(response.data.data));
      }
      return response;
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}

export function submitScheduleInterview(data) {
  return async (dispatch) => {
    try {
      const screen_name = dispatch(getNextScreenFromState());
      if (screen_name) {
        data = { ...data, screen_name };
      }
      data = { ...data, session_id: getUniqueSessionId() };
      const response = await makeApiCall({
        method: 'post',
        url: `${API_URL}/remitter/appointment`,
        withCredentials: true,
        data
      });
      if (response && response.data && response.data.success) {
        await dispatch(submitAppointment(response.data.data));
      }
      return response;
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}

export function updateScheduleInterview(data, appointment_request_id) {
  return async (dispatch) => {
    try {
      const screen_name = dispatch(getNextScreenFromState());
      if (screen_name) {
        data = { ...data, screen_name };
      }
      const response = await makeApiCall({
        method: 'patch',
        url: `${API_URL}/remitter/appointment/${appointment_request_id}`,
        withCredentials: true,
        data
      });
      if (response && response.data && response.data.success) {
        await dispatch(submitAppointment(response.data.data));
      }
      return response;
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}
